// extracted by mini-css-extract-plugin
export default {"wrapper":"tW-z","availablePromoMessagesLabel":"uW-z","promoMessageList":"vW-z","promoMessage":"wW-z","appliedPromoMessage":"xW-z","promoMessageAmount":"yW-z"};